import { render, staticRenderFns } from "./VesselSelect.vue?vue&type=template&id=848cf558&"
import script from "./VesselSelect.vue?vue&type=script&lang=ts&"
export * from "./VesselSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports